export const congeList = {
  leaves: {
    header_title: "Liste des demandes de congés",
    form: {
      title_edit: "Consulter la demande de congé",
      type: "Type de congé",
      comment: "Commentaire",
      justification: "Justification",
      calendar: "Calendrier",
      status: "Statut",
      createdAt: "Date de création",
      download_justif: "Télécharger la justification",
      notAvailable: "Non disponible",
      updatedAt: "Date de mise à jour",
    },
    modal: {
      information: "Informations de la demande",
      details: "Détails des congés",
    },
    actions: {
      view: "Consulter",
      validate: "Validée",
    },
  },
  common: {
    valid: "Validée",
    pending: "En attente",
  },
  messages: {
    validated: "La demande a été validée ✅",
    validate_error: "Erreur lors de la validation ❌",
  },
};
